import { SchemaItemError } from "./SchemaItemError"

/**
 * Wrapper error for iterable list of SchemaItemError items
 */
export class SchemaError extends Error {
    /**
     * @param itemArray SchemaItemError array
     */
    constructor(public readonly itemArray: SchemaItemError[]) {
        super("Invalid Schema")
        this.name = "SchemaError"
    }
}
